import React, { useState } from "react";
import Dropzone from "react-dropzone";
import uploadIcon from "../images/uploadIcon.svg";
import {
  getDataFromLocalStorage,
  setDataOnLocalStorage,
} from "../util/localStorage";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../config/apiConfig";
import AI_PDF_CONST from "../util/PdfAiConst";

import docx from "../images/docx-b.png";
import doc from "../images/doc-b.png";
import md from "../images/md-b.png";
import textIcon from "../images/text-b.png";
import pdfIcon from "../images/pdf-b.png";

const FileDropzone = ({ onUploadSuccess, onUploadError, uploadUrl }) => {
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [fileRejections, setFileRejections] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isMessageShow, setIsMessageShow] = useState(false);

  const handleDrop = (acceptedFiles, fileRejections) => {
    setAcceptedFiles(acceptedFiles);
    setFileRejections(fileRejections);
  };

  const navigate = useNavigate();

  const uploadFiles = async () => {
    const token = getDataFromLocalStorage("token"); // Fetch token from localStorage

    if (!token) {
      // Handle blank token error
      setIsMessageShow(true);
      setErrorMessage("Authorization token is missing. Please login again.");
      return;
    }

    const url = `${baseUrl + AI_PDF_CONST.API_ENDPOINT.DOCS}`; // Replace with your API endpoint
    const formData = new FormData();
    setSuccessMessage("File uploading...");
    setError(null); // Clear previous errors
    setIsMessageShow(false); // Clear previous error messages

    acceptedFiles.forEach((file) => formData.append("doc_filename", file));
    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await response.json(); // Parse the response JSON
      console.log("responseData", responseData);

      if (response.ok && responseData.data) {
        // Success case
        setDataOnLocalStorage("currentDoc", responseData.data);

        let docList = getDataFromLocalStorage("documentList") || []; // Ensure docList is an array if it's null or undefined
        docList.push(responseData.data); // Push the new document to the list

        setDataOnLocalStorage("documentList", docList); // Save the updated list to localStorage

        navigate(`/documents/${responseData.data.id}`);
      } else {
        // Handle server errors
        setIsMessageShow(true);
        console.log("res", responseData);
        setErrorMessage(responseData.message || "Failed to upload the file.");
      }
    } catch (error) {
      console.log("Upload error:", error);
      setIsMessageShow(true);
      setErrorMessage(error.message || "An unexpected error occurred.");
    } finally {
      setSuccessMessage(null); // Clear success message
    }
  };
  return (
    <div className="w-full">
      <div className="imgCol text-center bg-[#FAFAFC] border border-[#666] border-dashed rounded-lg">
        <Dropzone
          onDrop={handleDrop}
          accept={{
            "application/pdf": [".pdf"],
            "application/msword": [".doc"],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
              [".docx"],
            "text/plain": [".txt"],
            "text/markdown": [".md"],
          }}
          multiple={false}
        >
          {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
            <section>
              <div {...getRootProps()} className="p-[40px] mt-2 cursor-pointer">
                <input name="file" {...getInputProps()} />
                <img
                  src={uploadIcon}
                  alt="upload icon"
                  className="inline-block"
                />
                <p>Drag & drop files or Browse</p>
                <p>Supported formats: PDF</p>
                {isDragActive && <p>Drop the files here...</p>}
                {isDragReject && <p>Unsupported file type...</p>}
              </div>
            </section>
          )}
        </Dropzone>
      </div>
      <p className="max-w-[675px] sm:text-[14px] text-[12px] flex flex-row items-center justify-end mb-[15px]">
        We support a variety of file formats:
        <ul className="flex flex-row">
          <li>
            <span className=" p-[3px] inline-block rounded-[100%] mt-2">
              <img src={docx} className="h-[28px]" alt="codx icon" />
            </span>
          </li>
          <li>
            <span className=" p-[3px] inline-block rounded-[100%] mt-2">
              <img src={doc} className="h-[28px]" alt="codx icon" />
            </span>
          </li>
          <li>
            <span className=" p-[3px] inline-block rounded-[100%] mt-2">
              <img src={pdfIcon} className="h-[28px]" alt="codx icon" />
            </span>
          </li>
          <li>
            <span className=" p-[3px] inline-block rounded-[100%] mt-2">
              <img src={md} className="h-[28px]" alt="codx icon" />
            </span>
          </li>
          <li>
            <span className=" p-[3px] inline-block rounded-[100%] mt-2">
              <img src={textIcon} className="h-[28px]" alt="codx icon" />
            </span>
          </li>
        </ul>
      </p>
      {acceptedFiles.length > 0 && (
        <div className="acceptedFile mt-4">
          <h4>
            <strong>Accepted Files</strong>
          </h4>
          <ul>
            {acceptedFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        </div>
      )}

      {fileRejections.length > 0 && (
        <div className="rejectedFile mt-4">
          <h4>
            <strong>Rejected Files</strong>
          </h4>
          <ul>
            {fileRejections.map(({ file, errors }, index) => (
              <li key={index}>
                {file.name} - {errors.map((e) => e.message).join(", ")}
              </li>
            ))}
          </ul>
        </div>
      )}

      {successMessage && (
        <div className="mt-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative text-center">
          {successMessage}
          <div className="col-3 inline-block ml-[20px]">
            <div className="snippet" data-title="dot-pulse">
              <div className="stage">
                <div className="dot-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isMessageShow && (
        <div className="mt-4 text-red-500 text-center">{errorMessage}</div>
      )}
      <button
        onClick={uploadFiles}
        className={`${
          acceptedFiles.length > 0 ? "bg-black" : "bg-gray-300"
        } button text-white sm:px-4 sm:py-2 p-[5px] sm:text-[16px] text-[12px] mt-4 rounded`}
        disabled={acceptedFiles.length === 0}
      >
        UPLOAD FILES
      </button>
    </div>
  );
};

export default FileDropzone;
